import { applicantHistoryRequests } from "@/src/api/applicantHistoryRequests";

/**
 * Persist a History tab entry for an applicant (Full Name popup → History).
 * Failures are logged but do not throw — callers should not block the main action.
 */
export const createApplicantHistory = async (
  applicantId: number | null | undefined,
  text: string,
): Promise<boolean> => {
  const id = typeof applicantId === "number" ? applicantId : Number(applicantId);
  const trimmed = text.trim();
  if (!Number.isFinite(id) || id <= 0 || !trimmed) return false;

  try {
    const result = await applicantHistoryRequests.create({
      applicant_id: id,
      text: trimmed,
    });
    return result != null;
  } catch (error) {
    console.warn("[createApplicantHistory] failed:", error);
    return false;
  }
};

/** Match existing History wording used across Applications / Tasks / Full Name popup. */
export const buildFieldChangeHistoryText = (
  scope: "the student card" | "Office Accounting" | "the task" | "the application" | "documents",
  label: string,
  fromValue: string,
  toValue: string,
): string => {
  const from = fromValue.trim() || "—";
  const to = toValue.trim() || "—";
  return `Changes have been made to ${scope}: ${label} ${from} updated to ${to}`;
};

export const buildSimpleHistoryText = (
  scope: "the student card" | "Office Accounting" | "the task" | "the application" | "documents",
  message: string,
): string => `Changes have been made to ${scope}: ${message}`;
